module.exports = __webpack_public_path__ + "static/media/fertility-network.3cde455a.jpg";